export default __webpack_public_path__ + "static/media/meme_bg_dar.72b009bd.png";